import { workspaceActivitySchema } from '@mio/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '@/shared/api/client';
import { workspaceQuery } from '@/shared/api/queries/workspace';

/** "Keep working" counts as activity: it pushes back automatic idle shutdown. */
export function useKeepWorking() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiRequest('/workspaces/me/activity', workspaceActivitySchema, { method: 'POST' }),
    onSuccess: (activity) => {
      client.setQueryData(workspaceQuery.queryKey, (current) =>
        current?.workspace
          ? { ...current, workspace: { ...current.workspace, idleStopAt: activity.idleStopAt } }
          : current,
      );
      void client.invalidateQueries({ queryKey: workspaceQuery.queryKey });
    },
  });
}
